import {Button, IconButton} from '@wandb/components';
import React from 'react';

import {Analytics} from '../../../services/analytics';
import {type ConfigV2} from '../../../util/runfeed';
import {ModalTriggerButton} from '../../elements/ModalTriggerButton';
import {useRunSelectorAnalyticsLocation} from '../RunSelectorAnalyticsLocationContext';
import {useRunSelectorFeatureEnabled} from '../RunSelectorFeaturesContext';
import {RunsTableEditor} from '../TableEditor/RunsTableEditor';

type WBTableActionsProps = {
  expandable?: boolean;
  expanded?: boolean;
  extraTableActionsLeft?: React.ReactNode;
  extraTableActionsRight?: React.ReactNode;
  extraTableActionsTop?: React.ReactNode;
  fixedColumns: string[];
  setTableSettings: (config: ConfigV2) => void;
  tableSettings: ConfigV2;
};

export function WBTableActions({
  expandable,
  expanded,
  extraTableActionsLeft,
  extraTableActionsRight,
  extraTableActionsTop,
  fixedColumns,
  setTableSettings,
  tableSettings,
}: WBTableActionsProps) {
  const analyticsLocation = useRunSelectorAnalyticsLocation();
  const isEnabled = useRunSelectorFeatureEnabled();
  const buttonIcon = 'column';
  const buttonTooltip = 'Show, hide, or pin columns';
  const button = expanded ? (
    <Button
      variant="secondary"
      startIcon={buttonIcon}
      tooltip={{children: buttonTooltip}}>
      Columns
    </Button>
  ) : (
    <IconButton
      aria-label={buttonTooltip}
      icon={buttonIcon}
      variant="secondary"
      tooltip={{children: buttonTooltip}}
    />
  );

  const modalContent = (
    <RunsTableEditor
      fixedColumns={fixedColumns}
      config={tableSettings}
      update={setTableSettings}
      isTableExpandable={expandable}
    />
  );

  const showExtraActionsRight = !expandable || expanded;
  const showColumnEditor = isEnabled('edit-cols');

  return (
    <div className="wb-table-actions-wrapper">
      <span className="wb-table-actions-top">{extraTableActionsTop}</span>
      <div className="wb-table-actions">
        <div style={{display: 'flex', gap: 8}}>{extraTableActionsLeft}</div>
        <div style={{display: 'flex', gap: 8}}>
          {showExtraActionsRight ? extraTableActionsRight : null}
          {showColumnEditor ? (
            <ModalTriggerButton
              modalDataTest="run-selector-manage-columns-modal"
              buttonElement={button}
              modalHeader="Manage columns"
              modalContent={modalContent}
              onClick={() => {
                Analytics.track('Columns button clicked', {
                  location: analyticsLocation,
                });
              }}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}
